import { useState, useEffect, useRef, memo } from 'react';
import { CATEGORIES, WALLPAPERS } from '../../data/nfcData';
import { Av, PH } from '../../components/shared';
import { useApp } from '../../context/AppContext';
import * as api from '../../services/api';

export const PageCreateUser = memo(()=>{
  const { showToast } = useApp();
  const [form, setForm] = useState({
    firstName:"", lastName:"", email:"", phone:"",
    username:"", workPosition:"", jobTitle:"",
    company:"", address:"", category:"Sales", bio:"",
    password:"", showPw:false, subteam:"",
  });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const [subteams, setSubteams] = useState([]);
  const [profileImg, setProfileImg] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [coverImg, setCoverImg] = useState(null);
  const [coverFile, setCoverFile] = useState(null);
  const profileRef = useRef(null);
  const coverRef = useRef(null);

  useEffect(() => {
    api.getSubteams().then(res => {
      const d = res?.data ?? res;
      const items = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
      setSubteams(items);
    }).catch(() => {});
  }, []);

  const GRADS = [
    "linear-gradient(150deg,#64748b,#059669)",
    "linear-gradient(150deg,#18181b,#dc2626)",
    "linear-gradient(150deg,#d97706,#dc2626)",
    "linear-gradient(150deg,#059669,#0891b2)",
    "linear-gradient(150deg,#7c3aed,#0891b2)",
    "linear-gradient(150deg,#db2777,#f59e0b)",
  ];
  const [grad, setGrad]           = useState(GRADS[0]);
  const [wallpaper, setWallpaper] = useState(WALLPAPERS[0]);

  const av          = ((form.firstName[0]||"")+(form.lastName[0]||"")).toUpperCase() || "?";
  const displayName = (form.firstName||"First")+" "+(form.lastName||"Last");
  const previewUUID = form.username
    ? "usr_"+form.username.slice(0,8).padEnd(4,"0")
    : "usr_----";

  const genPassword = () => {
    const ch = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$%";
    set("password", Array.from({length:14}, ()=>ch[Math.floor(Math.random()*ch.length)]).join(""));
  };

  const pwStrength = (() => {
    const p = form.password;
    if (!p) return null;
    const s = p.length>=12 && /[A-Z]/.test(p) && /[0-9]/.test(p) && /[!@#$%]/.test(p) ? 3
            : p.length>=8 ? 2 : 1;
    return { s, col: s===3?"#059669":s===2?"#d97706":"#dc2626", lbl: s===3?"Strong":s===2?"Fair":"Weak" };
  })();

  /* ── Live Card Preview ── */
  const Preview = () => (
    <div style={{position:"sticky", top:24}}>
      <div className="ue-preview-label" style={{marginBottom:12}}>LIVE PREVIEW</div>

      {/* Phone shell */}
      <div style={{width:230, margin:"0 auto", background:"#1a1a2e", borderRadius:34,
        padding:"10px 6px 18px",
        boxShadow:"0 28px 60px rgba(0,0,0,.28), 0 4px 20px rgba(0,0,0,.18), inset 0 1px 0 rgba(255,255,255,.09)"}}>
        {/* notch */}
        <div style={{width:58,height:5,background:"#0d0d1a",borderRadius:3,margin:"0 auto 8px",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div style={{width:8,height:8,borderRadius:"50%",background:"#1e1e3a",border:"1px solid rgba(255,255,255,.08)"}}/>
        </div>
        {/* screen */}
        <div className="popl-card" style={{borderRadius:26,overflow:"hidden",width:"100%",margin:0,boxShadow:"none"}}>
          {/* wallpaper */}
          <div style={{height:100, background:coverImg?`url(${coverImg}) center/cover`:wallpaper}}/>
          {/* avatar */}
          <div style={{display:"flex",justifyContent:"center"}}>
            {profileImg ? (
              <div style={{width:66,height:66,borderRadius:"50%",border:"3px solid #fff",marginTop:-33,zIndex:2,boxShadow:"0 4px 14px rgba(0,0,0,.2)",overflow:"hidden"}}>
                <img src={profileImg} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              </div>
            ) : (
              <div style={{width:66,height:66,borderRadius:"50%",background:grad,border:"3px solid #fff",
                display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#fff",fontSize:20,
                marginTop:-33,zIndex:2,boxShadow:"0 4px 14px rgba(0,0,0,.2)"}}>
                {av}
              </div>
            )}
          </div>
          {/* name + info */}
          <div className="popl-info" style={{paddingTop:6}}>
            <div className="popl-name" style={{fontSize:13}}>{displayName}</div>
            {(form.jobTitle||form.workPosition)&&(
              <div className="popl-pos" style={{fontSize:10}}>
                {form.jobTitle||form.workPosition}{form.company?" · "+form.company:""}
              </div>
            )}
            {form.bio&&(
              <div className="popl-bio" style={{fontSize:9.5}}>
                {form.bio.slice(0,65)}{form.bio.length>65?"…":""}
              </div>
            )}
          </div>
          {/* contact pills */}
          <div style={{padding:"8px 10px 12px", display:"flex", flexDirection:"column", gap:5}}>
            {[form.email&&{ico:"📧",val:form.email}, form.phone&&{ico:"📞",val:form.phone}]
              .filter(Boolean).map((item,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:7,background:"#fff",
                  border:"1px solid #e2e8f0",borderRadius:9,padding:"6px 10px"}}>
                  <span style={{fontSize:12}}>{item.ico}</span>
                  <span style={{fontSize:10,color:"#334155",fontWeight:600,overflow:"hidden",
                    textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.val}</span>
                </div>
            ))}
            {!form.email&&!form.phone&&(
              <div style={{textAlign:"center",fontSize:10,color:"#94a3b8",padding:"4px 0"}}>
                Fill in email or phone to preview
              </div>
            )}
          </div>
          <div style={{textAlign:"center",paddingBottom:10,fontSize:9,color:"#cbd5e1"}}>
            Powered by Gotaps ✦
          </div>
        </div>
      </div>

      {/* UUID */}
      <div style={{marginTop:14,padding:"9px 12px",background:"rgba(255,255,255,.72)",
        border:"1px solid rgba(255,255,255,.9)",borderRadius:11,boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
        <div style={{fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
          textTransform:"uppercase",marginBottom:4}}>UUID Preview</div>
        <div style={{fontFamily:"monospace",fontSize:11,color:"#334155",letterSpacing:".04em"}}>
          {previewUUID}
        </div>
      </div>

      {/* Wallpaper picker */}
      <div style={{marginTop:12}}>
        <div style={{fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
          textTransform:"uppercase",marginBottom:7}}>Card Wallpaper</div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {WALLPAPERS.slice(0,8).map((w,i)=>(
            <div key={i} onClick={()=>setWallpaper(w)}
              style={{width:38,height:26,borderRadius:7,background:w,cursor:"pointer",transition:"all .14s",
                border:wallpaper===w?"2.5px solid #0f172a":"2.5px solid transparent",
                boxShadow:wallpaper===w?"0 0 0 3px rgba(0,0,0,.12)":"none"}}/>
          ))}
        </div>
      </div>

      {/* Avatar color */}
      <div style={{marginTop:12}}>
        <div style={{fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
          textTransform:"uppercase",marginBottom:7}}>Avatar Color</div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {GRADS.map((g,i)=>(
            <div key={i} onClick={()=>setGrad(g)}
              style={{width:28,height:28,borderRadius:"50%",background:g,cursor:"pointer",
                display:"flex",alignItems:"center",justifyContent:"center",
                fontSize:10,fontWeight:800,color:"#fff",transition:"all .14s",
                border:grad===g?"2.5px solid #0f172a":"2.5px solid transparent",
                boxShadow:grad===g?"0 0 0 3px rgba(0,0,0,.12)":"none"}}>
              {grad===g?"✓":""}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="pg fi">
      <PH eyebrow="Team" title="Create User" sub="Add a new member to your workspace"/>

      <div style={{display:"flex", gap:24, alignItems:"flex-start"}}>

        {/* ──────────── FORM ──────────── */}
        <div style={{flex:1, minWidth:0}}>
          <div className="card-s" style={{padding:"24px 26px"}}>

            {/* Personal */}
            <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
              textTransform:"uppercase",marginBottom:14}}>Personal Info</div>

            <div className="frow">
              <div className="fg" style={{marginBottom:0}}>
                <label>First Name</label>
                <input className="inp" placeholder="Alex"
                  value={form.firstName} onChange={e=>set("firstName",e.target.value)}/>
              </div>
              <div className="fg" style={{marginBottom:0}}>
                <label>Last Name</label>
                <input className="inp" placeholder="Smith"
                  value={form.lastName} onChange={e=>set("lastName",e.target.value)}/>
              </div>
            </div>

            <div className="frow" style={{marginTop:12}}>
              <div className="fg" style={{marginBottom:0}}>
                <label>Email</label>
                <input className="inp" type="email" placeholder="alex@company.com"
                  value={form.email} onChange={e=>set("email",e.target.value)}/>
              </div>
              <div className="fg" style={{marginBottom:0}}>
                <label>Phone</label>
                <input className="inp" placeholder="+1 555 000 0000"
                  value={form.phone} onChange={e=>set("phone",e.target.value)}/>
              </div>
            </div>

            <div className="fg" style={{marginTop:12}}>
              <label>
                Username
                <span style={{fontSize:10,color:"#94a3b8",fontWeight:400,marginLeft:5}}>
                  * unique handle
                </span>
              </label>
              <div style={{position:"relative"}}>
                <span style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",
                  fontSize:13,color:"#94a3b8",pointerEvents:"none"}}>@</span>
                <input className="inp" style={{paddingLeft:24}} placeholder="alexsmith"
                  value={form.username}
                  onChange={e=>set("username", e.target.value.replace(/[^a-z0-9_.-]/gi,"").toLowerCase())}/>
              </div>
            </div>

            {/* Professional */}
            <div style={{height:1,background:"rgba(0,0,0,.06)",margin:"20px 0 16px"}}/>
            <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
              textTransform:"uppercase",marginBottom:14}}>Professional Info</div>

            <div className="frow">
              <div className="fg" style={{marginBottom:0}}>
                <label>Work Position</label>
                <input className="inp" placeholder="e.g. Sales Lead"
                  value={form.workPosition} onChange={e=>set("workPosition",e.target.value)}/>
              </div>
              <div className="fg" style={{marginBottom:0}}>
                <label>Job Title</label>
                <input className="inp" placeholder="e.g. Sr. Account Executive"
                  value={form.jobTitle} onChange={e=>set("jobTitle",e.target.value)}/>
              </div>
            </div>

            <div className="fg" style={{marginTop:12}}>
              <label>Company</label>
              <input className="inp" placeholder="Gotaps Enterprise"
                value={form.company} onChange={e=>set("company",e.target.value)}/>
            </div>

            <div className="fg">
              <label>Address</label>
              <input className="inp" placeholder="City, State / Country"
                value={form.address} onChange={e=>set("address",e.target.value)}/>
            </div>

            <div className="frow">
              <div className="fg" style={{marginBottom:0}}>
                <label>Category</label>
                <select className="inp" value={form.category}
                  onChange={e=>set("category",e.target.value)}>
                  {CATEGORIES.map(c=><option key={c}>{c}</option>)}
                </select>
              </div>
              <div className="fg" style={{marginBottom:0}}>
                <label>Subteam</label>
                <select className="inp" value={form.subteam}
                  onChange={e=>set("subteam",e.target.value)}>
                  <option value="">None</option>
                  {subteams.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
              </div>
            </div>

            <div className="fg" style={{marginTop:12}}>
              <label>Bio</label>
              <textarea className="inp" placeholder="Short bio shown on the digital card…"
                value={form.bio} onChange={e=>set("bio",e.target.value)}
                style={{minHeight:76, resize:"vertical"}}/>
              <div style={{fontSize:10.5,color:"var(--t4)",marginTop:3,textAlign:"right"}}>
                {form.bio.length}/160
              </div>
            </div>

            {/* Photos */}
            <div style={{height:1,background:"rgba(0,0,0,.06)",margin:"20px 0 16px"}}/>
            <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
              textTransform:"uppercase",marginBottom:14}}>Profile Media</div>

            <div className="frow">
              <div className="fg" style={{marginBottom:0}}>
                <label>Profile Photo <span style={{fontSize:10,color:"#94a3b8",fontWeight:400}}>· 400×400px (1:1)</span></label>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  {profileImg ? (
                    <div style={{width:56,height:56,borderRadius:"50%",overflow:"hidden",border:"2px solid rgba(255,255,255,.9)",boxShadow:"0 2px 10px rgba(0,0,0,.12)",flexShrink:0}}>
                      <img src={profileImg} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                    </div>
                  ) : (
                    <div style={{width:56,height:56,borderRadius:"50%",background:grad,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:18,color:"#fff",flexShrink:0,border:"2px solid rgba(255,255,255,.9)"}}>{av}</div>
                  )}
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    <button className="btn bp" style={{fontSize:11,padding:"5px 12px",gap:5}} onClick={()=>profileRef.current?.click()}>📷 Upload</button>
                    {profileImg&&<button className="btn bd" style={{fontSize:11,padding:"5px 12px"}} onClick={()=>{setProfileImg(null);setProfileFile(null);}}>✕ Remove</button>}
                  </div>
                </div>
                <input ref={profileRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                  const f=e.target.files[0]; if(!f) return;
                  setProfileFile(f);
                  const r=new FileReader(); r.onload=ev=>setProfileImg(ev.target.result); r.readAsDataURL(f);
                }}/>
              </div>
              <div className="fg" style={{marginBottom:0}}>
                <label>Cover Photo <span style={{fontSize:10,color:"#94a3b8",fontWeight:400}}>· 1125×633px (16:9)</span></label>
                <div style={{height:56,borderRadius:10,overflow:"hidden",position:"relative",border:"1px solid rgba(0,0,0,.08)",background:coverImg?`url(${coverImg}) center/cover`:wallpaper,cursor:"pointer"}}
                  onClick={()=>coverRef.current?.click()}>
                  <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,.2)",opacity:0,transition:"opacity .15s"}}
                    onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0}>
                    <span style={{color:"#fff",fontSize:12,fontWeight:600}}>📷 Change</span>
                  </div>
                </div>
                <input ref={coverRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                  const f=e.target.files[0]; if(!f) return;
                  setCoverFile(f);
                  const r=new FileReader(); r.onload=ev=>setCoverImg(ev.target.result); r.readAsDataURL(f);
                }}/>
                {coverImg&&<button onClick={()=>{setCoverImg(null);setCoverFile(null);}} style={{fontSize:11,padding:"2px 9px",borderRadius:6,border:"1px solid rgba(220,38,38,.2)",background:"rgba(220,38,38,.07)",color:"#dc2626",cursor:"pointer",fontFamily:"var(--f)",marginTop:6}}>✕ Remove cover</button>}
              </div>
            </div>

            {/* Security */}
            <div style={{height:1,background:"rgba(0,0,0,.06)",margin:"20px 0 16px"}}/>
            <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",
              textTransform:"uppercase",marginBottom:14}}>Access & Security</div>

            <div className="fg" style={{marginBottom:0}}>
              <label>Password</label>
              <div style={{display:"flex",gap:8}}>
                <div style={{position:"relative",flex:1}}>
                  <input className="inp"
                    type={form.showPw?"text":"password"}
                    placeholder="Set a secure password…"
                    value={form.password}
                    onChange={e=>set("password",e.target.value)}
                    style={{paddingRight:40,
                      fontFamily:form.showPw?"var(--f)":"monospace",
                      letterSpacing:form.showPw?"normal":".14em"}}/>
                  <button onClick={()=>set("showPw",!form.showPw)}
                    style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",
                      background:"none",border:"none",cursor:"pointer",fontSize:15,color:"#94a3b8",padding:0}}>
                    {form.showPw?"🙈":"👁"}
                  </button>
                </div>
                <button className="btn bs" style={{whiteSpace:"nowrap",gap:6,flexShrink:0}}
                  onClick={genPassword}>
                  ⚡ Generate
                </button>
              </div>

              {/* Strength indicator */}
              {pwStrength&&(
                <div style={{display:"flex",alignItems:"center",gap:8,marginTop:8}}>
                  <div style={{display:"flex",gap:3}}>
                    {[1,2,3].map(i=>(
                      <div key={i} style={{width:28,height:4,borderRadius:2,transition:"background .22s",
                        background:i<=pwStrength.s?pwStrength.col:"rgba(0,0,0,.1)"}}/>
                    ))}
                  </div>
                  <span style={{fontSize:11,fontWeight:660,color:pwStrength.col}}>
                    {pwStrength.lbl}
                  </span>
                  {pwStrength.s<3&&(
                    <span style={{fontSize:10.5,color:"#94a3b8"}}>
                      — use 12+ chars, uppercase, numbers & symbols
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Actions */}
            <div style={{display:"flex",gap:9,marginTop:24}}>
              <button className="btn bp"
                style={{flex:1,justifyContent:"center",gap:7}}
                onClick={async ()=>{
                  if(!form.firstName||!form.email){showToast("Name and Email are required","error");return;}
                  if(!form.username){showToast("Username is required","error");return;}
                  if(!form.password||form.password.length<8){showToast("Password must be at least 8 characters","error");return;}
                  if(!form.email.includes("@")){showToast("Please enter a valid email","error");return;}
                  try {
                    const fd = new FormData();
                    fd.append('name', `${form.firstName} ${form.lastName}`.trim());
                    fd.append('email', form.email);
                    fd.append('password', form.password);
                    fd.append('username', form.username);
                    fd.append('phone', form.phone || '');
                    fd.append('job_title', form.jobTitle || '');
                    fd.append('company', form.company || '');
                    fd.append('address', form.address || '');
                    fd.append('bio', form.bio || '');
                    if (profileFile) fd.append('photo', profileFile);
                    if (coverFile) fd.append('cover_photo', coverFile);
                    if (!profileFile) fd.append('profile_color', grad || '');
                    if (!coverFile) fd.append('cover_color', wallpaper || '');
                    const res = await api.createMember(fd);
                    showToast(`✅ ${form.firstName} ${form.lastName} created successfully!`);
                    // Navigate back to users list
                    window.location.href = '/team/users';
                  } catch(e) {
                    let msg = e.message || "Failed to create user";
                    if (e.errors) { const first = Object.values(e.errors)[0]; msg = Array.isArray(first) ? first[0] : first; }
                    showToast(msg, "error");
                  }
                }}>
                ✅ Create User
              </button>
            </div>

          </div>
        </div>

        {/* ──────────── LIVE PREVIEW ──────────── */}
        <div style={{width:258, flexShrink:0}}>
          <Preview/>
        </div>

      </div>
    </div>
  );
});

